<template>
  <transition name="controller">
    <div v-if="nodesDataArray && nodesDataArray.length > 1 && paneBounds[0] !== paneBounds[2] && isControllerCanVisible"
         class="controller"
         :class="{
           'backward': !isForwardDirection
         }"
         :style="{
           left: controllerX + 'px'
         }"
         @mousemove.stop>
      <button type="button"
              :class="{ 'disabled': isControllerPrevDisabled }"
              @click="() => onControllerClick('start')">To Start</button>
      <button type="button"
              :class="{ 'disabled': isControllerPrevDisabled }"
              @click="() => onControllerClick('prev')">Previous Sequence</button>
      <button type="button"
              :class="{ 'disabled': isControllerNextDisabled }"
              @click="() => onControllerClick('next')">Next Sequence</button>
      <button type="button"
              :class="{ 'disabled': isControllerNextDisabled }"
              @click="() => onControllerClick('end')">To End</button>
    </div>
  </transition>
</template>

<script>
import browser from '@/libs/browser'

export default {
  name: 'BaTargetingSequenceController',
  components: {
  },
  data () {
    return {
      controllerX: false,
      isControllerCanVisible: false
    }
  },
  props: {
    nodesDataArray: {
      type: Array,
      required: true
    },
    gridWidth: {
      type: Number,
      required: true
    },
    paneScale: {
      type: Number,
      required: true
    },
    paneWrapSize: {
      type: Array,
      required: true
    },
    panePosition: {
      type: Array,
      required: true
    },
    paneBounds: {
      type: Array,
      required: true
    },
    croppedDisplayableIndex: {
      type: Number,
      required: true
    },
    isForwardDirection: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isControllerPrevDisabled () {
      return this.isForwardDirection ? this.panePosition[0] >= this.paneBounds[0] : this.paneBounds[2] >= this.panePosition[0]
    },
    isControllerNextDisabled () {
      return this.isForwardDirection ? this.paneBounds[2] >= this.panePosition[0] : this.panePosition[0] >= this.paneBounds[0]
    }
  },
  watch: {
    panePosition () {
      !browser.isMobile && setTimeout(this.onBodyMouseMove, 550)
    },
    isControllerCanVisible (visible) {
      if (visible) {
        this.controllerX = this._lastPoint[0]
      }
    }
  },
  mounted () {
    this._$body = document.body
    window.addEventListener('resize', this.onWindowResize)
    this._$body.addEventListener('mousemove', this.onBodyMouseMove)
    this.onWindowResize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
    this._$body.removeEventListener('mousemove', this.onBodyMouseMove)
  },
  methods: {
    onBodyMouseMove (e) {
      if (e) {
        this._lastPoint = getEventPoint(e)
      }
      // const wasControllerCanVisible = this.isControllerCanVisible
      this.isControllerCanVisible = false
      if (!this._$body.classList.contains('dragging') && this._lastPoint) {
        const $listBox = document.querySelector('.ba-targeting-list')
        if ($listBox) {
          const [ pointX, pointY ] = this._lastPoint
          const paneWrapTop = this._windowHeight - this.paneWrapSize[1]
          if (pointY > paneWrapTop) {
            // this.isControllerCanVisible = paneWrapTop + 32 + (wasControllerCanVisible ? 14 : 0) > pointY

            let startX = $listBox.getBoundingClientRect().left
            if (this.isForwardDirection) {
              startX += 425 * this.paneScale
            }

            const scaledGridWidth = this.gridWidth * this.paneScale
            for (let i = 0; i < this.croppedDisplayableIndex; i++) {
              if (pointX >= startX + i * scaledGridWidth && startX + (i + 1) * scaledGridWidth >= pointX) {
                this.$emit('setFocusedGridIndex', this.isForwardDirection ? i + 1 : this.croppedDisplayableIndex - i)
                return
              }
            }
          }
        }
      }
      this.$emit('setFocusedGridIndex', -1)
    },
    onWindowResize () {
      this._windowHeight = window.innerHeight
    },

    onControllerClick (flag) {
      let x
      if (this.isForwardDirection) {
        if (flag === 'start') {
          x = 0
        } else if (flag === 'prev') {
          x = this.panePosition[0] + this.gridWidth
        } else if (flag === 'next') {
          x = this.panePosition[0] - this.gridWidth
        } else {
          x = -Infinity
        }
      } else {
        if (flag === 'start') {
          x = -Infinity
        } else if (flag === 'prev') {
          x = this.panePosition[0] - this.gridWidth
        } else if (flag === 'next') {
          x = this.panePosition[0] + this.gridWidth
        } else {
          x = 0
        }
      }
      this.$emit('setPanePosition', x, this.panePosition[1])
    }
  }
}

function getEventPoint (e) {
  if (e.touches) {
    e = e.touches[0] || e.changedTouches[0]
  }
  return [e.pageX || e.clientX, e.pageY || e.clientY]
}
</script>

<style lang="scss" scoped>
.controller {
  position: absolute;
  left: 50%;
  top: 18px;
  width: 115px;
  height: 28px;
  margin-left: -57px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 17px 14px -5px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.22), 0 1px 3px 0 rgba(0, 0, 0, 0.06);
  display: flex;
  overflow: hidden;
  z-index: 10;

  &-enter-active, &-leave-active {
    transition: opacity 0.15s ease-out;
  }
  &-enter, &-leave-to {
    opacity: 0;
  }

  button {
    position: relative;
    flex: 1;
    text-indent: -999em;
    overflow: hidden;
    transition: background-color 0.2s;

    &:not(:last-child) {
      border-right: 1px solid #ebebeb;
    }

    &.disabled:before {
      opacity: 0.3;
      pointer-events: none;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.06);
    }

    &:before {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 14px;
      height: 14px;
      content: '';
      margin: -7px 0 0 -7px;
      background: url('../../assets/img/targeting/icon--navigate-next.svg') no-repeat 50% 50%;
      transition: opacity 0.1s ease-out;
    }

    &:nth-child(1):before,
    &:nth-child(4):before {
      background: url('../../assets/img/targeting/icon--navigate-next-end.svg') no-repeat 50% 50%;
    }

    &:nth-child(1):before,
    &:nth-child(2):before {
      transform: scaleX(-1);
    }
  }

  &.backward {
    flex-direction: row-reverse;

    button {
      &:nth-child(1) {
        border-right: 0;
      }
      &:nth-child(4) {
        border-right: 1px solid #ebebeb;
      }
      &:nth-child(1):before,
      &:nth-child(2):before {
        transform: none;
      }
      &:nth-child(3):before,
      &:nth-child(4):before {
        transform: scaleX(-1);
      }
    }
  }
}
</style>
